export default [
  {
    path: '/mrmr',
    name: 'MRMR',
    component: () => import('@/app/geo/MRMR.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'MRMR', active: true, i18n: 'MRMR.Title' }
      ],
      requireAuth: true,
      requireRoles: [
        'GeoReaders',
        'MRMRReaders',
        'MRMRCollaborators',
        'MRMRConsolidation',
        'Admin'
      ],
      pageTitle: 'MRMR',
      i18n: 'MRMR.Title',
      rule: 'editor'
    }
  },
  {
    path: '/mrmr/scenarios',
    name: 'geo-scenarios',
    component: () => import('@/app/geo/scenarios/Scenarios.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'MRMR', url: '/mrmr', i18n: 'MRMR.Title'},
        { title: 'Scenarios', active: true, i18n: 'GeoScenarioPage.Title' }
      ],
      requireAuth: true,
      requireRoles: [
        'GeoWriters',
        'Admin'
      ],
      pageTitle: 'Scenarios',
      i18n: 'Scenarios'
    }
  },
  {
    path: '/mrmr/nsr',
    name: 'geo-nsr',
    component: () => import('@/app/geo/analytics/nsr.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'MRMR', url: '/mrmr', i18n: 'MRMR.Title'},
        { title: 'NSR', active: true, i18n: 'Geo.NSR.Title' }
      ],
      requireAuth: true,
      requireRoles: [
        'GeoReaders',
        'Admin'
      ],
      pageTitle: 'NSR Analytics',
      rule: 'editor'
    }
  },
  {
    path: '/mrmr/geostats',
    name: 'geo-geostats',
    component: () => import('@/app/geo/analytics/geostats.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'MRMR', url: '/mrmr', i18n: 'MRMR.Title'},
        { title: 'Model QA/QC', active: true, i18n: 'Geo.QAQC.Title' }
      ],
      requireAuth: true,
      requireRoles: [
        'GeoReaders',
        'Admin'
      ],
      pageTitle: 'Model QA/QC',
      rule: 'editor'
    }
  },
  {
    path: '/mrmr/variances',
    name: 'geo-variances',
    component: () => import('@/app/geo/MRMR/variances/index.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'MRMR', url: '/mrmr', i18n: 'MRMR.Title'},
        { title: 'Variances', active: true, i18n: 'MRMR.Variances.Title' }
      ],
      requireAuth: true,
      requireRoles: [
        'MRMRCollaborators',
        'GeoReaders',
        'Admin'
      ],
      pageTitle: 'Variance Reports',
      rule: 'editor'
    }
  },
  {
    path: '/mrmr/variances/upload',
    name: 'mrmr-variances-upload',
    component: () => import('@/app/geo/MRMR/variances/upload.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'MRMR', url: '/mrmr', i18n: 'MRMR.Title'},
        { title: 'Variances', url: '/mrmr/variances', i18n: 'MRMR.Variances.Title' },
        { title: 'Upload', active: true, i18n: 'MRMR.Variances.Upload.Title' }
      ],
      requireAuth: true,
      requireRoles: [
        'MRMRCollaborators',
        'GeoReaders',
        'Admin'
      ],
      i18n: 'MRMR.Variances.Upload.Title',

      rule: 'editor'
    }
  }
]